import { ReactElement } from 'react';
import ModalWrapper from '../../components/modals/ModalWrapper';
import ModalHeader from '../../components/modals/ModalHeader';
import { IonContent } from '@ionic/react';
import { StoreInterface } from '../../../../store/types';
import { useSelector } from 'react-redux';
import { PaymentGateway } from '../../../../services/exports/Constants';
import { IModal } from '../../router/ModalRouter';
import { useTranslation } from 'react-i18next';
import StripePaymentMethodsList from './StripePaymentMethodsList';
import AdyenPaymentMethodsList from './AdyenPaymentMethodsList';

const PaymentMethodsModal = ({ openModal, goBack, closeModal, isBack }: Partial<IModal>): ReactElement => {
  const { t } = useTranslation(null, {
    keyPrefix:
      'Modules:Mobile:Features:Profile:Components:ProfileModal:NestedModals:PaymentMethods:PaymentMethodsModal',
  });
  const { company } = useSelector((state: StoreInterface) => state.initialData);
  const onlinePaymentsGateway = company?.payment_gateways?.[0];
  const isAdyen = onlinePaymentsGateway === PaymentGateway.Adyen;
  // Spreedly shares the generic saved-options list, but the "add a card" path
  // is a Stripe SetupIntent — a Spreedly card is only ever saved at checkout.
  const isSpreedly = onlinePaymentsGateway === PaymentGateway.Spreedly;

  return (
    <ModalWrapper className="mt-4">
      <ModalHeader title={t('title')} onBack={goBack} onClose={closeModal} />
      <IonContent className="min-h-[75dvh] [&::part(scroll)]:py-4 space-y-md">
        {isAdyen ? (
          <AdyenPaymentMethodsList openModal={openModal} isBack={isBack} />
        ) : (
          <StripePaymentMethodsList openModal={openModal} canAddCard={!isSpreedly} />
        )}
      </IonContent>
    </ModalWrapper>
  );
};

export default PaymentMethodsModal;
